import { CdpaButtonComponent, CdpaButtonId } from "../../../common/components/cdpaButton.component";
import { CdpaInputComponent, CdpaInputId } from "../../../common/components/cdpaInput.component";
import { attachValidationOnSubmitClick } from "../formHelpers/formHelpers";
import { enableEmailRestoring } from "../formHelpers/emailRestoreHelpers";
import { FormId } from "../common/formId";
import "./update-email.scss";
export class UpdateEmail {
    constructor() {
        const form = document.getElementById(FormId.UpdateEmailForm);
        const emailInput = new CdpaInputComponent(CdpaInputId.Email);
        const submitButton = new CdpaButtonComponent(CdpaButtonId.UpdateEmailConfirm);
        attachValidationOnSubmitClick(submitButton, form, [emailInput]);
        enableEmailRestoring(CdpaButtonId.UpdateEmailConfirm, emailInput);
    }
}
